export default Object.freeze({
  Execution: 0,
  Approved: 1,
  Rejected: 2,
  Canceled: 3,
  Voided: 4,
  Error: 5,
});
